import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import { SendTypeScreen } from './components/SendTypeScreen'
import { SendTypeCardView } from './components/SendTypeCardView'
import { SendType } from 'src/catalog/components/CardOptions/CardOptions'
import { useMeasurements, useSelector } from 'src/hooks'

export const SelectSendType = (props: {
  shouldShowAct: boolean
  cardFrontPanelImageUrl: string
  cardInsideRightImagePreview?: string
  isHorizontal: boolean
  cardTitle?: string
  cardSubtitle?: string
  primaryFont: string
  onSelectSendType: (sendType: SendType) => void
  selectedSendType: SendType
  isDisplayingInsideRightImagePreview: boolean
  onSeeInside: () => void
  onEditCustomCard?: () => void
}) => {
  const {
    shouldShowAct,
    cardFrontPanelImageUrl,
    cardInsideRightImagePreview,
    isHorizontal,
    cardTitle,
    cardSubtitle,
    primaryFont,
    isDisplayingInsideRightImagePreview,
    onSeeInside,
    onSelectSendType,
    selectedSendType,
    onEditCustomCard,
  } = props

  const { windowWidth } = useMeasurements()
  const isScreenTooSmall = windowWidth <= 400
  const isMobile = useSelector(state => state.window.isMobile)

  return (
    <Flex
      flexDirection="column"
      inset={'x1'}
      justifyContent={isMobile ? 'flex-start' : 'center'}
      width={'100%'}
      overflowY="auto"
      overflowX="hidden"
    >
      <Flex flexDirection="column" alignItems={'center'} width={'100%'}>
        {cardTitle && (
          <Text
            type="title"
            lineHeight={1.5}
            content={cardTitle}
            style={{
              fontFamily: primaryFont,
              fontSize: '1rem',
              fontWeight: 800,
              color: '#000',
              width: '100%',
              textAlign: 'center',
              minHeight: '1.5rem',
            }}
          />
        )}
        {cardSubtitle && (
          <Text
            type="subtitle"
            lineHeight={1.5}
            content={cardSubtitle}
            style={{
              fontFamily: primaryFont,
              fontSize: '.8rem',
              minWidth: '200px',
              fontWeight: 500,
              color: '#000',
              width: '100%',
              textAlign: 'center',
              minHeight: '1rem',
            }}
          />
        )}
      </Flex>

      {onEditCustomCard && (
        <div
          onClick={onEditCustomCard}
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '12px',
            width: '100%',
            fontFamily: 'Montserrat, sans-serif',
            alignItems: 'center',
            fontWeight: 600,
            color: '#404040',
            fontSize: '16px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          Edit & Save
        </div>
      )}

      {shouldShowAct && (
        <>
          <Text
            type="body"
            content="Send Type:"
            inset={{ top: isMobile ? 'x0' : 'x3' }}
            style={{
              fontFamily: primaryFont,
              fontSize: '.625rem',
              fontWeight: 700,
              color: '#000',
              width: '100%',
              textAlign: 'start',
            }}
          />
          <Div
            display="grid"
            justifyContent="center"
            style={{
              gridTemplateColumns: isScreenTooSmall
                ? 'repeat(2, 9rem)'
                : 'repeat(2, 10rem)',
              gap: 12,
            }}
          >
            <SendTypeScreen
              isSelected={selectedSendType === SendType.Digital}
              onClick={() => onSelectSendType(SendType.Digital)}
              title={'Immediate Delivery\nDigital Card'}
              cardView={
                <SendTypeCardView
                  cardImageUrl={cardFrontPanelImageUrl}
                  size="2rem"
                  isHorizontal={isHorizontal}
                  isDigital={true}
                />
              }
            />
            <SendTypeScreen
              isSelected={selectedSendType === SendType.Print}
              onClick={() => onSelectSendType(SendType.Print)}
              title={'Printed Card\nDelivered By Mail'}
              isScreenToSmall={isScreenTooSmall}
              cardView={
                <SendTypeCardView
                  cardImageUrl={cardFrontPanelImageUrl}
                  size="2rem"
                  isHorizontal={isHorizontal}
                  isDigital={false}
                />
              }
            />
          </Div>
        </>
      )}
      {cardInsideRightImagePreview && (
        <div
          onClick={onSeeInside}
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: isMobile ? '16px' : '32px',
            width: '100%',
            fontFamily: 'Montserrat, sans-serif',
            alignItems: 'center',
            fontWeight: 600,
            color: '#404040',
            fontSize: '16px',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {isDisplayingInsideRightImagePreview ? 'See Front' : 'See Inside'}
        </div>
      )}
    </Flex>
  )
}
